// extracted by mini-css-extract-plugin
module.exports = {"itemBehind":"SwipeableList_itemBehind__111XI","item":"SwipeableList_item__3MnEp","list":"SwipeableList_list__38wuB"};